import type { Ref } from "vue";
import type { HeadlessItem } from "../types";
import { useState } from "#imports";

export type HeadlessItemError = {
  statusCode?: number;
  statusMessage?: string;
  cause?: Error;
  data?: never;
};
export const useHeadlessDataState = (): Ref<HeadlessItem | null> => useState<HeadlessItem | null>( "headless", () => null );

export const useHeadlessDataErrorState = (): Ref<HeadlessItemError | null> => useState<HeadlessItemError | null>( "headless-error", () => null );

export const useHeadlessCultureState = (): Ref<string | null> => useState<string | null>( "culture", () => null );
